import React from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from '../../../../PropTypes';
import { Form, Col, Row } from 'react-bootstrap';

const parseBooleanOrNull = (value) => {
  if (value === 'true' || value === true) return true;
  if (value === 'false' || value === false) return false;
  return null;
};

const RailAndFlySection = ({ flyToWorkTicketInfo, setFlyToWorkTicketInfo, handleUpdateFlightTicketInfo }) => (
  <div hidden={!parseBooleanOrNull(flyToWorkTicketInfo.isRailAndFly)}>
    <hr />
    <Row>
      <Form.Group as={Col}>
        <Form.Label>Train station name</Form.Label>
        <Form.Control
          type="text"
          value={flyToWorkTicketInfo.homeTrainStationName || ''}
          onChange={(e) => setFlyToWorkTicketInfo({ ...flyToWorkTicketInfo, homeTrainStationName: e.target.value })}
          onBlur={(e) => handleUpdateFlightTicketInfo('homeTrainStationName', e.target.value)}
        />
      </Form.Group>
    </Row>
  </div>
);

RailAndFlySection.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  setFlyToWorkTicketInfo: PropTypes.func.isRequired,
  handleUpdateFlightTicketInfo: PropTypes.func.isRequired,
};

export default React.memo(RailAndFlySection);
